import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Navbar,
  Nav,
  NavItem,
  NavDropdown,
  MenuItem,
  InputGroup,
  Glyphicon,
  Image,
  ListGroup,
  ListGroupItem,
  Carousel,
  Tabs,
  Tab,
  Table,
  Well,
  Alert,
} from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { withRouter, Link } from "react-router-dom";

import isEmpty from "lodash.isempty";
import Pagination from "react-paginating";

import "./dashboard.scss";
import {
  getCartDetail,
  updateCart,
  removeItem,
  selectAttributes,
} from "../../../redux/actions/frontActions";

import ReactHtmlParser from "react-html-parser";

import moment from "moment";

import Cookies from "universal-cookie";

import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";

import languageConfig from "../../../config/languageConfig";
import { appConfig } from "../../../config/appConfig";

const cookies = new Cookies();
//  // real time notification for deal quantity
const PUSHER_EVENT = appConfig.PUSHER_EVENT || "inv-event";
const PUSHER_CHANNEL = appConfig.PUSHER_CHANNEL || "payvibe-channel";

const history = createBrowserHistory();
let cart = "",
  isLoading = "false",
  validateData = [],
  attributes = [],
  currentIndex = "",
  locID = [];
function Currency(props) {
  const cur = props.default_currency == "EUR" ? "€" : "$";
  return (
    <span className={props.className}>
      {props.default_lang == "en" ? cur : ""}
      {props.amount}
      {props.default_lang == "fr" ? cur : ""}
    </span>
  );
}
class Cart extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };
  constructor(props, context) {
    super(props, context);
    this.state = {
      index: 0,
      direction: null,
      menuList: "",
      quantity: [],
      cartError: "",
      show: false,
      alertMessage: "",
      hover: false,
      validateData: [],
      multi_lang: "no",
      lang: "",
      default_lang: cookies.get("default_lang")
        ? cookies.get("default_lang")
        : "en",
      currency: "",
      symbol: "",
      taxes: "disable",
      UpdatecartStatus: "",
      message: "",
      siteId: "",
      isPusherActive: false,
      channel: this.props.pusher.subscribe(PUSHER_CHANNEL),
      remaining_qty_obj: {},
      isValidateRemainingQty: true,
    };
    validateData = [];
    attributes = [];
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleAttribute = this.handleAttribute.bind(this);
  }

  hoverOn = (e) => {
    this.setState({
      hover: true,
      hoverID: e.target.attributes.getNamedItem("data-id")
        ? e.target.attributes.getNamedItem("data-id").value
        : null,
    });
  };

  hoverOff = (e) => {
    this.setState({
      hover: false,
      hoverID: e.target.attributes.getNamedItem("data-id")
        ? e.target.attributes.getNamedItem("data-id").value
        : null,
    });
  };

  checkDuplicateInObject(inputArray) {
    var seenDuplicate = false,
      testObject = [];
    let tmpinputArray = Object.keys(inputArray).map(function (k) {
      return inputArray[k];
    });
    tmpinputArray.map(function (item, iKey) {
      item = Object.keys(item)
        .map(function (k, i) {
          return k.replace('"', "").replace('"', "") + " :: " + item[k];
        })
        .join(", ");
      testObject.push({ data: item, qty: 1 });
      delete tmpinputArray[iKey];
    });
    return testObject;
  }

  handleSubmit = (e) => {
    e.preventDefault();
    let checkDuplicateInObject = this.checkDuplicateInObject;
    validateData.map(function (item, iKey) {
      if (
        validateData[iKey]["attributes"] &&
        validateData[iKey]["attributes"]["attribute"]
      ) {
        validateData[iKey].rawAttribute = checkDuplicateInObject(
          validateData[iKey]["attributes"]["attribute"]
        );
      }
    });
    let newAarray = [];

    this.state.cart.map((data, key) => {
      if (validateData[key]) {
        newAarray.push(validateData[key]);
      } else {
        newAarray.push({
          dealID: data.dealID,
          dealLocationID: "",
          quantity: data.quantity,
        });
      }
    });
    let constData = {
      details: newAarray,
      userKey: cookies.get("token"),
      lang: this.state.default_lang,
    };
    isLoading = "true";
    this.props.selectAttributes(constData);
  };

  autocalculatetax = (data, index, name, quantity, dealID) => {
    let qtyIndex = null;
    let dealLocationID = "";
    let cart = this.state.cart[index];
    if (
      cart.useMerchantDefaultTax == 0 &&
      cart.isTaxable == 1 &&
      this.state.taxes == "enable"
    ) {
      let dealLocation = this.state.cart[index].dealLocation;
      if (dealLocation && data[0].dealLocationID !== "") {
        dealLocation.map((tax, pindex) => {
          if (tax.dealLocationID == parseInt(data[0].dealLocationID)) {
            const newAttribute = this.state.cart.map((data, pidx) => {
              if (parseInt(index) != parseInt(pidx)) return data;
              return {
                ...data,
                tax: tax.taxPerc,
                total: (
                  parseInt(data.quantity) *
                    parseFloat(data.offerPrice) *
                    parseFloat(tax.taxPerc) +
                  parseFloat(
                    parseInt(data.quantity) * parseFloat(data.offerPrice) +
                      parseInt(data.shipping)
                  )
                ).toFixed(2),
              };
            });
            this.setState({ cart: newAttribute });
          }
        });
      } else {
        const newAttribute = this.state.cart.map((data, pidx) => {
          if (parseInt(index) != parseInt(pidx)) return data;
          return {
            ...data,
            tax: 0.0,
            total: (
              parseInt(data.quantity) * parseFloat(data.offerPrice) +
              parseInt(data.shipping)
            ).toFixed(2),
          };
        });
        this.setState({ cart: newAttribute });
      }
    }

    let targetVal = data[0].dealLocationID;
    if (name == "locID") {
      if (!Array.isArray(locID[index])) {
        locID[index] = [];
      }

      locID[index] = targetVal;
    } else {
      if (currentIndex == "") {
        currentIndex = index;
        attributes = [];
      } else {
        if (currentIndex != index) {
          currentIndex = index;
          attributes = [];
        }
      }

      if (qtyIndex) {
        let attrName = '"' + name + '"';

        if (!attributes[index]) {
          attributes = {
            [index]: { attribute: { [qtyIndex]: { [attrName]: targetVal } } },
          };
        }

        if (!attributes[index]["attribute"][qtyIndex]) {
          if (
            Object.entries(attributes[index]["attribute"]).length === 0 &&
            attributes[index]["attribute"].constructor === Object
          ) {
            attributes[index]["attribute"] = {
              [qtyIndex]: { [attrName]: targetVal },
            };
          } else {
            attributes[index]["attribute"] = Object.assign(
              attributes[index]["attribute"],
              { [qtyIndex]: { [attrName]: targetVal } }
            );
          }
        }
        if (attributes[index]["attribute"][qtyIndex]) {
          if (!attributes[index]["attribute"][qtyIndex][attrName]) {
            attributes[index]["attribute"][qtyIndex] = Object.assign(
              attributes[index]["attribute"][qtyIndex],
              { [attrName]: targetVal }
            );
          } else {
            attributes[index]["attribute"][qtyIndex][attrName] = targetVal;
          }
        }

        attributes["quantity"] = quantity;
      }
    }
    const constData = {
      dealID: dealID,
      dealLocationID: locID[index] ? locID[index] : "",
      quantity: quantity,
    };
    if (attributes[index]) {
      constData.attributes = Object.assign({}, attributes[index]);
    }
    validateData[index] = constData;
    this.setState({ validateData: validateData });
  };

  handleAttribute = (e) => {
    let dealID = e.target.attributes.getNamedItem("data-dealid").value;
    let name = e.target.attributes.getNamedItem("data-name").value;
    let index = e.target.attributes.getNamedItem("data-index").value;
    let quantity = e.target.attributes.getNamedItem("data-quantity").value;
    let qtyIndex = e.target.attributes.getNamedItem("data-qtyindex")
      ? e.target.attributes.getNamedItem("data-qtyindex").value
      : null;
    let cartID = e.target.attributes.getNamedItem("data-cartID").value;
    let dealLocationID = "";
    let cart = this.state.cart[index];

    if (
      cart.useMerchantDefaultTax == 0 &&
      cart.isTaxable == 1 &&
      this.state.taxes == "enable"
    ) {
      let dealLocation = this.state.cart[index].dealLocation;
      if (dealLocation && e.target.value !== "") {
        dealLocation.map((tax, pindex) => {
          if (tax.dealLocationID === parseInt(e.target.value)) {
            const newAttribute = this.state.cart.map((data, pidx) => {
              if (parseInt(index) !== parseInt(pidx)) return data;
              return {
                ...data,
                tax: tax.taxPerc,
                total: (
                  parseInt(data.quantity) *
                    parseFloat(data.offerPrice) *
                    parseFloat(tax.taxPerc) +
                  parseFloat(
                    parseInt(data.quantity) * parseFloat(data.offerPrice) +
                      parseInt(data.shipping)
                  )
                ).toFixed(2),
              };
            });
            this.setState({ cart: newAttribute });
          }
        });
      } else {
        const newAttribute = this.state.cart.map((data, pidx) => {
          if (parseInt(index) !== parseInt(pidx)) return data;
          return {
            ...data,
            tax: 0.0,
            total: (
              parseInt(data.quantity) * parseFloat(data.offerPrice) +
              parseInt(data.shipping)
            ).toFixed(2),
          };
        });
        this.setState({ cart: newAttribute });
      }
    }

    let targetVal = e.target.value;
    if (name == "locID") {
      if (!Array.isArray(locID[index])) {
        locID[index] = [];
      }
      locID[index] = targetVal;
    } else {
      validateData = this.state.validateData;

      attributes[index] = validateData[index].attributes;
      // if (currentIndex == "") {
      //   currentIndex = index;
      //   attributes = [];
      // } else {
      //   if (currentIndex != index) {
      //     currentIndex = index;
      //     attributes = [];
      //   }
      // }

      if (qtyIndex) {
        let attrName = '"' + name + '"';

        if (!attributes[index]) {
          attributes[index] = {
            attribute: { [qtyIndex]: { [attrName]: targetVal } },
          };
        }

        if (!attributes[index]["attribute"][qtyIndex]) {
          if (
            Object.entries(attributes[index]["attribute"]).length === 0 &&
            attributes[index]["attribute"].constructor === Object
          ) {
            attributes[index]["attribute"] = {
              [qtyIndex]: { [attrName]: targetVal },
            };
          } else {
            attributes[index]["attribute"] = Object.assign(
              attributes[index]["attribute"],
              { [qtyIndex]: { [attrName]: targetVal } }
            );
          }
        }
        if (attributes[index]["attribute"][qtyIndex]) {
          if (!attributes[index]["attribute"][qtyIndex][attrName]) {
            attributes[index]["attribute"][qtyIndex] = Object.assign(
              attributes[index]["attribute"][qtyIndex],
              { [attrName]: targetVal }
            );
          } else {
            attributes[index]["attribute"][qtyIndex][attrName] = targetVal;
          }
        }

        attributes["quantity"] = quantity;
      }
    }
    const constData = {
      dealID: dealID,
      dealLocationID: locID[index] ? locID[index] : "",
      quantity: quantity,
    };
    if (attributes[index]) {
      constData.attributes = Object.assign({}, attributes[index]);
    }
    validateData[index] = constData;
    this.setState({ validateData: validateData });
    this.props.updateCart({
      cartID: cartID,
      quantity: 1,
      quantityType: "",
      attributes: !isEmpty(constData.attributes) ? constData.attributes : "",
      lang: this.state.default_lang,
      dealLocationID: locID[index] ? locID[index] : null,
    });
  };

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  // setQuantity = (
  //   cartID,
  //   type,
  //   currentValue,
  //   indexKey,
  //   dealLocation,
  //   dealID
  // ) => {
  //   isLoading = "true";
  //   // if(((parseInt(this.state.remaining_qty_obj[dealID]) == 0) || (type =='add' && parseInt(this.state.remaining_qty_obj[dealID]) <= currentValue))){
  //   //   isLoading = "false";
  //   //   return true;
  //   // }else{
  //   let attr = validateData[indexKey];
  //   let checkAttr = this.state.cart;
  //   let quantity;
  //   if (type === "add") {
  //     quantity = currentValue + 1;
  //     // if(this.state.remaining_qty_obj[dealID] && parseInt(this.state.remaining_qty_obj[dealID]) > 0){
  //     //   let tmpNewQty = parseInt(this.state.remaining_qty_obj[dealID]) - 1
  //     //   this.setState({remaining_qty_obj: {...this.state.remaining_qty_obj, [dealID] : tmpNewQty}})
  //     // }
  //   } else {
  //     validateData = [];
  //     attributes = [];
  //     this.setState({ validateData: validateData });
  //     quantity = currentValue - 1;
  //     // if(this.state.remaining_qty_obj[dealID] && (parseInt(this.state.remaining_qty_obj[dealID]) > 0 && currentValue <= parseInt(this.state.remaining_qty_obj[dealID]) && quantity > 0)){
  //     //   let tmpNewQty = parseInt(this.state.remaining_qty_obj[dealID]) + 1
  //     //   this.setState({remaining_qty_obj: {...this.state.remaining_qty_obj, [dealID] : tmpNewQty}})
  //     // }
  //   }

  //   if (
  //     attr &&
  //     attr.attributes &&
  //     attr.attributes.attribute &&
  //     !isEmpty(attr.attributes.attribute)
  //   ) {
  //     attr.attributes.attribute = attr.attributes.attribute.filter(
  //       (_, i) => i < quantity
  //     );
  //   }
  //   if (!isEmpty(checkAttr[indexKey].attributes) && dealLocation == true) {
  //     if (isEmpty(attr)) {
  //       isLoading = "false";
  //       this.handleShow();
  //       this.setState({
  //         alertMessage: "Please select attribute.",
  //         msgType: "danger",
  //       });
  //     } else {
  //       if (quantity >= 1) {
  //         this.props.updateCart({
  //           cartID: cartID,
  //           quantity: 1,
  //           quantityType: type,
  //           attributes: attr.attributes,
  //           lang: this.state.default_lang,
  //         });
  //       } else {
  //         isLoading = "false";
  //         this.handleShow();
  //         this.setState({
  //           alertMessage:
  //             "At least one quantity is required for each deal/offer.",
  //           msgType: "danger",
  //         });
  //       }
  //     }
  //   } else {
  //     if (quantity >= 1) {
  //       this.props.updateCart({
  //         cartID: cartID,
  //         quantity: 1,
  //         quantityType: type,
  //         attributes:
  //           !isEmpty(attr) && !isEmpty(attr.attributes) ? attr.attributes : "",
  //         lang: this.state.default_lang,
  //       });
  //     } else {
  //       isLoading = "false";
  //       this.handleShow();
  //       this.setState({
  //         alertMessage:
  //           "At least one quantity is required for each deal/offer.",
  //         msgType: "danger",
  //       });
  //     }
  //   }
  //   // }
  // };

 setQuantity = (cartID, type, currentValue, indexKey, dealLocation, dealID) => {
  isLoading = "true";

  const attr = validateData[indexKey];
  const checkAttr = this.state.cart;
  let quantity = type === "add" ? currentValue + 1 : currentValue - 1;

  if (type === "sub") {
    validateData = [];
    attributes = [];
    this.setState({ validateData: validateData });
  }

  if (
    attr &&
    attr.attributes &&
    attr.attributes.attribute &&
    !isEmpty(attr.attributes.attribute)
  ) {
    attr.attributes.attribute = attr.attributes.attribute.slice(0, quantity);
  }

  const updateCartIfValid = () => {
    this.props.updateCart({
      cartID: cartID,
      quantity: 1,
      quantityType: type,
      attributes:
        attr && attr.attributes && !isEmpty(attr.attributes)
          ? attr.attributes
          : "",
      lang: this.state.default_lang,
    });
  };

  const showAlert = (msg) => {
    isLoading = "false";
    this.handleShow();
    this.setState({ alertMessage: msg, msgType: "danger" });
  };

  if (
    checkAttr[indexKey] &&
    !isEmpty(checkAttr[indexKey].attributes) &&
    dealLocation === true
  ) {
    if (isEmpty(attr)) {
      showAlert("Please select attribute.");
    } else if (quantity >= 1) {
      updateCartIfValid();
    } else {
      showAlert("At least one quantity is required for each deal/offer.");
    }
  } else {
    if (quantity >= 1) {
      updateCartIfValid();
    } else {
      showAlert("At least one quantity is required for each deal/offer.");
    }
  }
};



  handlePageChange = (page) => {
    let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));
    //alert("handlePageChange"+siteData.default_city);
    if (siteData) {
      this.siteId = siteData.siteID;
      this.isPusherActive =
        siteData.broadcasting && siteData.broadcasting == "enable"
          ? true
          : false;
      if (siteData.default_city || siteData.multi_lang == "yes") {
        this.setState({
          multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: cookies.get("default_lang")
            ? cookies.get("default_lang")
            : siteData.default_lang,
          default_city: siteData.default_city,
        });
      }
    }
    isLoading = "true";
    this.props.getCartDetail({
      userKey: cookies.get("token"),
      iscart: "1",
      default_city: siteData.default_city,
      lang: cookies.get("default_lang")
        ? cookies.get("default_lang")
        : siteData.default_lang
        ? siteData.default_lang
        : this.state.default_lang,
    });
  };

  componentWillMount() {
    let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));
    //alert("componentWillMount"+siteData.default_city);
    this.props.clearAlert();
    if (siteData) {
      if (siteData.default_city || siteData.multi_lang == "yes") {
        this.setState({
          multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: cookies.get("default_lang")
            ? cookies.get("default_lang")
            : siteData.default_lang,
          taxes: siteData.taxes ? siteData.taxes : "disable",
          default_city: siteData.default_city,
        });
      }
      this.setState({
        taxes: siteData.taxes ? siteData.taxes : "disable",
      });
    }

    if (this.props.themeData) {
      if (this.props.themeData.button) {
        this.setState({
          button_color: this.props.themeData.button.button_color,
          mouseover_color: this.props.themeData.button.mouseover_color,
        });
      }
    }
    this.handleDismiss();
    this.handlePageChange(1);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.language) {
      if (this.state.default_lang !== nextProps.language) {
        this.setState({ default_lang: nextProps.language });
        this.props.getCartDetail({
          userKey: cookies.get("token"),
          iscart: "1",
          lang: nextProps.language,
        });
      }
    }

    if (nextProps.currency) {
      this.setState({ currency: nextProps.currency, symbol: nextProps.symbol });
    }

    if (nextProps.themeData) {
      if (nextProps.themeData.button) {
        this.setState({
          button_color: nextProps.themeData.button.button_color,
          mouseover_color: nextProps.themeData.button.mouseover_color,
        });
      }
    }
    // cart detail
    if (this.props.cartDetail != nextProps.cartDetail) {
      if (nextProps.cartDetail) {
        isLoading = "false";
        validateData = this.state.validateData;
        validateData = nextProps.cartDetail.data.data.map((val, idx) => {
          let attributes = val.cart_attributes
            ? JSON.parse(val.cart_attributes)
            : "";
          return {
            attributes: attributes,
            dealID: val.dealID,
            dealLocationID: val.dealLocationID,
            quantity: val.quantity,
          };
        });

        this.setState({
          cart: nextProps.cartDetail.data.data,
          validateData: validateData,
        });

        // real time notification for deal quantity
        if (this.isPusherActive) {
          let tmpCart = [...nextProps.cartDetail.data.data];
          let tmpRemQ = { ...this.state.remaining_qty_obj };
          this.state.channel.bind(PUSHER_EVENT, (data) => {
            let tmpSiteId = data.siteId ? parseInt(data.siteId) : "";
            let tmpDealID = data.dealID ? data.dealID : "";
            if (this.siteId == tmpSiteId) {
              tmpCart.map((v) => {
                if (v.dealID == tmpDealID) {
                  let tmpQty = data.quantity ? parseInt(data.quantity) : 0;
                  tmpRemQ[tmpDealID] = tmpQty;
                  this.setState({ remaining_qty_obj: tmpRemQ });
                  if (tmpQty <= 0) {
                    this.setState({ isValidateRemainingQty: false });
                  }
                }
                return { ...v };
              });
            }
          });
        }
      }
    }

    if (this.props.cartDetail != nextProps.cartDetail) {
      if (nextProps.cartDetail.data.data.length == 0) {
        isLoading = "false";
        cart = "empty";
      }
    }
    // cart status
    if (this.state.UpdatecartStatus != nextProps.UpdatecartStatus) {
      if (nextProps.UpdatecartStatus) {
        isLoading = "false";
        this.props.clearAlert();
        this.setState({ UpdatecartStatus: nextProps.UpdatecartStatus });
        if (nextProps.UpdatecartStatus.response === "error") {
          this.handleShow();
          this.props.renderAlert("danger", nextProps.UpdatecartStatus.message);
          this.props.getCartDetail({
            userKey: cookies.get("token"),
            iscart: "1",
            lang: cookies.get("default_lang")
              ? cookies.get("default_lang")
              : this.state.default_lang,
            test: "yes",
          });
          //this.handlePageChange(1);
          window.scrollTo(0, 0);
        } else if (nextProps.UpdatecartStatus.response === "success") {
          //this.handlePageChange(1);
          this.props.getCartDetail({
            userKey: cookies.get("token"),
            iscart: "1",
            lang: cookies.get("default_lang")
              ? cookies.get("default_lang")
              : this.state.default_lang,
            test: "yes",
          });
        } else {
          this.handlePageChange(1);
        }
      }
    }

    if (this.props.cartError !== nextProps.cartError) {
      if (nextProps.cartError) {
        isLoading = "false";
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.cartError);
        isLoading = "false";
      }
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        isLoading = "false";
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
        isLoading = "false";
      }
    }

    if (this.state.message !== nextProps.message) {
      this.handleShow();
      this.setState({
        message: nextProps.message,
        alertMessage: nextProps.message,
        msgType: nextProps.alertType,
      });
    }

    if (this.props.attribute !== nextProps.attribute) {
      if (nextProps.attribute) {
        isLoading = "false";
        this.props.clearAlert();
        if (nextProps.attribute.response == "error") {
          this.handleShow();
          this.props.renderAlert("danger", nextProps.attribute.message);
          window.scrollTo(0, 0);
        } else {
          this.context.router.history.push(`/checkout`);
        }
      }
    }
  }

  componentWillUpdate(nextProps, nextState) {
    if (this.state.cartDetail != nextState.cartDetail) {
      if (nextState.cartDetail) {
        this.setState({ cart: nextState.cartDetail });
      }
    }
  }

  removeItem = (e, index) => {
    isLoading = "true";
    validateData.splice(index, 1);
    let removeItem = this.state.cart;
    removeItem.splice(index, 1);
    this.setState({ cart: removeItem });
    if (removeItem.length === 0) {
      cart = "empty";
    }
    this.props.removeItem(e);
  };

  render() {
    // Internet Explorer 6-11
    const isIE = /*@cc_on!@*/ false || !!document.documentMode;

    // Edge 20+
    const isEdge = !isIE && !!window.StyleMedia;

    let validateData = this.state.validateData;
    const { index, direction } = this.state;
    let cartItem,
      i = 1,
      total = 0,
      subRetailPrice = 0,
      subOfferPrice = 0,
      subTotalShipping = 0,
      taxPerc = 0,
      subTotalQty = 0;

    if (!isEmpty(this.state.cart)) {
      cartItem = this.state.cart.map((cart, index) => {
        total = parseFloat(total) + parseFloat(cart.total);
        subTotalQty = parseFloat(subTotalQty) + parseFloat(cart.quantity);
        subRetailPrice =
          parseFloat(subRetailPrice) + parseFloat(cart.retailPrice);
        subOfferPrice = parseFloat(subOfferPrice) + parseFloat(cart.offerPrice);
        taxPerc = parseFloat(taxPerc) + parseFloat(cart.tax);
        subTotalShipping =
          parseFloat(subTotalShipping) + parseFloat(cart.shipping);
      });
    }

    return (
      <div>
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        {isEmpty(this.state.cart) && cart == "empty" ? (
          <div className="container margin-top text-center">
            <Well bsSize="large">
              <h1>{languageConfig[this.state.default_lang].cart_page}</h1>
            </Well>
            <Button
              bsStyle="success"
              style={{
                backgroundColor:
                  this.state.hover && this.state.hoverID == "Continue Shoping"
                    ? this.state.mouseover_color
                    : this.state.button_color
                    ? this.state.button_color
                    : "#77C84E",
              }}
              data-id={"Continue Shoping"}
              onMouseEnter={this.hoverOn}
              onMouseLeave={this.hoverOff}
              type="submit"
              onClick={() => this.context.router.history.push(`/`)}
            >
              {languageConfig[this.state.default_lang].continue_shopping}
            </Button>
          </div>
        ) : (
          <div className="container">
            {this.state.show &&
              this.state.alertMessage !== "" &&
              this.state.msgType && (
                <div className="col-lg-12">
                  <Alert
                    bsStyle={this.state.msgType}
                    onDismiss={this.handleDismiss}
                  >
                    <strong>Message:</strong>{" "}
                    {this.state.alertMessage
                      ? ReactHtmlParser(this.state.alertMessage)
                      : ""}
                  </Alert>
                </div>
              )}
            <form onSubmit={this.handleSubmit}>
              <Table
                striped
                bordered
                condensed
                hover
                className={
                  "cartgrid " +
                  (this.state.default_lang == "en" ? " " : "badge-fr ")
                }
              >
                <thead style={{ backgroundColor: "#f3f4f5" }}>
                  <tr>
                    <th>#</th>
                    <th>{languageConfig[this.state.default_lang].offer}</th>
                    <th>{languageConfig[this.state.default_lang].qty}</th>
                    <th>
                      {languageConfig[this.state.default_lang].retail_price}
                    </th>
                    <th>
                      {languageConfig[this.state.default_lang].offer_price}
                    </th>
                    <th>{languageConfig[this.state.default_lang].shipping}</th>
                    {this.state.taxes == "enable" && (
                      <th>{languageConfig[this.state.default_lang].tax}</th>
                    )}
                    <th>{languageConfig[this.state.default_lang].total}</th>
                    <th>{languageConfig[this.state.default_lang].action}</th>
                  </tr>
                </thead>
                <tbody>
                  {!isEmpty(this.state.cart)
                    ? (cartItem = this.state.cart.map((cart, indexKey) => (
                        <tr key={Math.random()}>
                          <td className="none">{i++}</td>
                          <td className="offer">
                            {ReactHtmlParser(
                              cart.mainDealText + " (" + cart.merchantName + ")"
                            )}
                            {cart.ismulti == true ? (
                              <p>{ReactHtmlParser(cart.dealText)}</p>
                            ) : (
                              ""
                            )}

                            <div>
                              {!isEmpty(cart.dealLocation) &&
                                cart.requireLocation == "1" && (
                                  <Row
                                    className="margin-top"
                                    key={Math.random()}
                                  >
                                    <Col md={12} xs={12} key={Math.random()}>
                                      {cart.dealLocation.length > 1 && (
                                        <FormGroup key={Math.random()}>
                                          <Col sm={6}>
                                            {
                                              languageConfig[
                                                this.state.default_lang
                                              ].location
                                            }
                                          </Col>

                                          <Col sm={6}>
                                            <FormControl
                                              componentClass="select"
                                              defaultValue={
                                                validateData[indexKey]
                                                  ? validateData[indexKey]
                                                      .dealLocationID
                                                  : ""
                                              }
                                              placeholder="select"
                                              data-quantity={cart.quantity}
                                              data-index={indexKey}
                                              data-id={indexKey}
                                              data-dealid={cart.dealID}
                                              data-cartID={cart.cartID}
                                              data-name="locID"
                                              onChange={this.handleAttribute}
                                              required={
                                                cart.requireLocation == "1"
                                                  ? true
                                                  : false
                                              }
                                            >
                                              <option value="">Select</option>
                                              {!isEmpty(cart.dealLocation) &&
                                                cart.dealLocation.map(
                                                  (value, index) => (
                                                    <option
                                                      key={index}
                                                      value={
                                                        value.dealLocationID
                                                      }
                                                    >
                                                      {value.locAddress1},
                                                      {value.locAddress2
                                                        ? value.locAddress2 +
                                                          ","
                                                        : ""}
                                                      {value.locCity +
                                                        ", " +
                                                        value.locState +
                                                        ", " +
                                                        value.locCountry}
                                                    </option>
                                                  )
                                                )}
                                            </FormControl>
                                          </Col>
                                        </FormGroup>
                                      )}
                                      {cart.dealLocation.length == 1 &&
                                      cart.dealLocation[0].taxPerc !=
                                        cart.tax &&
                                      cart.useMerchantDefaultTax == 0 &&
                                      cart.isTaxable == 1 &&
                                      cart.shipable == 0 &&
                                      this.state.taxes == "enable"
                                        ? this.autocalculatetax(
                                            cart.dealLocation,
                                            indexKey,
                                            "locID",
                                            cart.quantity,
                                            cart.dealID
                                          )
                                        : ""}
                                    </Col>
                                  </Row>
                                )}
                              {!isEmpty(cart.attributes) &&
                                _.range(cart.quantity).map(
                                  (gtyVal, qtyIndex) => {
                                    return cart.attributes.map(
                                      (attrData, index) => {
                                        let name = '"' + attrData.name + '"';
                                        let valids = [];
                                        let valid = this.state.validateData;
                                        valid =
                                          valid[indexKey] &&
                                          valid[indexKey]["attributes"]
                                            ? valid[indexKey]["attributes"]
                                            : "";
                                        valid =
                                          valid && valid.attribute
                                            ? valid.attribute[qtyIndex]
                                            : "";

                                        if (valid) {
                                          Object.keys(valid).map(
                                            (i) => (valids[i] = valid[i])
                                          );
                                        }
                                        return (
                                          <Row
                                            className="margin-top"
                                            key={Math.random()}
                                          >
                                            <Col
                                              md={12}
                                              xs={12}
                                              key={Math.random()}
                                            >
                                              <FormGroup key={Math.random()}>
                                                <Col sm={6}>
                                                  {
                                                    languageConfig[
                                                      this.state.default_lang
                                                    ].item
                                                  }{" "}
                                                  {qtyIndex + 1}{" "}
                                                  {
                                                    languageConfig[
                                                      this.state.default_lang
                                                    ].attribute
                                                  }{" "}
                                                  : {attrData.name}{" "}
                                                </Col>
                                                <Col sm={6}>
                                                  <FormControl
                                                    componentClass="select"
                                                    defaultValue={
                                                      valids ? valids[name] : ""
                                                    }
                                                    placeholder="select"
                                                    data-quantity={
                                                      cart.quantity
                                                    }
                                                    data-qtyindex={qtyIndex}
                                                    data-index={indexKey}
                                                    data-id={cart.dealID}
                                                    data-dealid={cart.dealID}
                                                    data-name={attrData.name}
                                                    data-cartID={cart.cartID}
                                                    onChange={
                                                      this.handleAttribute
                                                    }
                                                    required
                                                  >
                                                    <option value="">
                                                      Select
                                                    </option>
                                                    {!isEmpty(
                                                      attrData.dataValue
                                                    ) &&
                                                      attrData.dataValue.map(
                                                        (value, index) => (
                                                          <option
                                                            key={index}
                                                            value={
                                                              attrData.type ==
                                                              "menu"
                                                                ? value
                                                                : moment(
                                                                    value.startDateTime
                                                                  ).format(
                                                                    "YYYY-MM-DD HH:mm"
                                                                  ) +
                                                                  " to " +
                                                                  moment(
                                                                    value.endDateTime
                                                                  ).format(
                                                                    "YYYY-MM-DD HH:mm"
                                                                  )
                                                            }
                                                          >
                                                            {attrData.type ==
                                                            "menu"
                                                              ? value
                                                              : moment(
                                                                  value.startDateTime
                                                                ).format(
                                                                  "YYYY-MM-DD HH:mm"
                                                                ) +
                                                                " to " +
                                                                moment(
                                                                  value.endDateTime
                                                                ).format(
                                                                  "YYYY-MM-DD HH:mm"
                                                                )}
                                                          </option>
                                                        )
                                                      )}
                                                  </FormControl>
                                                </Col>
                                              </FormGroup>
                                            </Col>
                                          </Row>
                                        );
                                      }
                                    );
                                  }
                                )}
                            </div>
                            {cart.termsAndConditions && (
                              <React.Fragment>
                                <hr />
                                <b>
                                  {languageConfig[this.state.default_lang].term}
                                  :
                                </b>{" "}
                                {ReactHtmlParser(cart.termsAndConditions)}
                              </React.Fragment>
                            )}
                            {cart.checkoutNotes !== "" &&
                              cart.checkoutNotes !== "null" && (
                                <React.Fragment>
                                  <hr />
                                  <span className="text-danger">
                                    <b>
                                      {cart.checkoutNotes
                                        ? `${
                                            languageConfig[
                                              this.state.default_lang
                                            ].note
                                          }: `
                                        : ""}
                                    </b>{" "}
                                    {cart.checkoutNotes}
                                  </span>
                                </React.Fragment>
                              )}
                          </td>
                          <td className="qty">
                            <FormGroup style={{ marginBottom: "0" }}>
                              <InputGroup>
                                <InputGroup.Button>
                                  {isIE == false && isEdge == false ? (
                                    <Button
                                      bsStyle="danger"
                                      style={{
                                        backgroundColor:
                                          this.state.hover &&
                                          this.state.hoverID ==
                                            "minus-" + cart.dealID
                                            ? this.state.mouseover_color
                                            : this.state.button_color,
                                      }}
                                      data-id={"minus-" + cart.dealID}
                                      onMouseEnter={this.hoverOn}
                                      onMouseLeave={this.hoverOff}
                                      onClick={this.setQuantity.bind(
                                        this,
                                        cart.cartID,
                                        "sub",
                                        cart.quantity,
                                        indexKey,
                                        !isEmpty(cart.dealLocation)
                                          ? true
                                          : false,
                                        cart.dealID
                                      )}
                                    >
                                      <i className="glyphicon glyphicon-minus" />
                                    </Button>
                                  ) : (
                                    <Button
                                      bsStyle="danger"
                                      style={{
                                        backgroundColor:
                                          this.state.hover &&
                                          this.state.hoverID ==
                                            "minus-" + cart.dealID
                                            ? this.state.mouseover_color
                                            : this.state.button_color,
                                      }}
                                      data-id={"minus-" + cart.dealID}
                                      onClick={this.setQuantity.bind(
                                        this,
                                        cart.cartID,
                                        "sub",
                                        cart.quantity,
                                        indexKey,
                                        !isEmpty(cart.dealLocation)
                                          ? true
                                          : false,
                                        cart.dealID
                                      )}
                                    >
                                      <i className="glyphicon glyphicon-minus" />
                                    </Button>
                                  )}
                                </InputGroup.Button>
                                <FormControl
                                  type="text"
                                  value={cart.quantity}
                                  placeholder="Qty"
                                  name="quantity"
                                  readOnly
                                  className="qty"
                                />
                                <InputGroup.Button>
                                  {isIE == false && isEdge == false ? (
                                    <Button
                                      style={{
                                        backgroundColor:
                                          this.state.hover &&
                                          this.state.hoverID ==
                                            "plus-" + cart.dealID
                                            ? this.state.mouseover_color
                                            : this.state.button_color
                                            ? this.state.button_color
                                            : "#77C84E",
                                      }}
                                      data-id={"plus-" + cart.dealID}
                                      onMouseEnter={this.hoverOn}
                                      onMouseLeave={this.hoverOff}
                                      bsStyle="success"
                                      onClick={this.setQuantity.bind(
                                        this,
                                        cart.cartID,
                                        "add",
                                        cart.quantity,
                                        indexKey,
                                        !isEmpty(cart.dealLocation)
                                          ? true
                                          : false,
                                        cart.dealID
                                      )}
                                    >
                                      <i className="glyphicon glyphicon-plus" />
                                    </Button>
                                  ) : (
                                    <Button
                                      style={{
                                        backgroundColor:
                                          this.state.hover &&
                                          this.state.hoverID ==
                                            "plus-" + cart.dealID
                                            ? this.state.mouseover_color
                                            : this.state.button_color
                                            ? this.state.button_color
                                            : "#77C84E",
                                      }}
                                      data-id={"plus-" + cart.dealID}
                                      bsStyle="success"
                                      onClick={this.setQuantity.bind(
                                        this,
                                        cart.cartID,
                                        "add",
                                        cart.quantity,
                                        indexKey,
                                        !isEmpty(cart.dealLocation)
                                          ? true
                                          : false,
                                        cart.dealID
                                      )}
                                    >
                                      <i className="glyphicon glyphicon-plus" />
                                    </Button>
                                  )}
                                </InputGroup.Button>
                              </InputGroup>
                            </FormGroup>
                            {parseInt(
                              this.state.remaining_qty_obj[cart.dealID]
                            ) >= 0 ? (
                              <span className="quantity-left">
                                Quantity Left{" "}
                                {this.state.remaining_qty_obj[cart.dealID]}
                              </span>
                            ) : (
                              ""
                            )}
                          </td>
                          <td className="rprice">
                            <Currency
                              amount={cart.retailPrice}
                              default_lang={this.state.default_lang}
                              className=""
                              default_currency={this.state.currency}
                            />
                          </td>
                          <td className="oprice">
                            <Currency
                              amount={cart.offerPrice}
                              default_lang={this.state.default_lang}
                              className=""
                              default_currency={this.state.currency}
                            />
                          </td>
                          <td className="shipping">
                            <Currency
                              amount={cart.shipping}
                              default_lang={this.state.default_lang}
                              className=""
                              default_currency={this.state.currency}
                            />
                          </td>
                          {this.state.taxes == "enable" && (
                            <td className="tax">{cart.tax}%</td>
                          )}
                          <td className="total">
                            <Currency
                              amount={cart.total}
                              default_lang={this.state.default_lang}
                              className=""
                              default_currency={this.state.currency}
                            />
                          </td>
                          <td>
                            {isIE == false && isEdge == false ? (
                              <Button
                                style={{
                                  backgroundColor:
                                    this.state.hover &&
                                    this.state.hoverID == "trash-" + cart.dealID
                                      ? this.state.mouseover_color
                                      : this.state.button_color,
                                }}
                                data-id={"trash-" + cart.dealID}
                                onMouseEnter={this.hoverOn}
                                onMouseLeave={this.hoverOff}
                                bsStyle="danger"
                                onClick={this.removeItem.bind(
                                  this,
                                  cart.cartID,
                                  indexKey
                                )}
                              >
                                <i className="glyphicon glyphicon-trash" />
                              </Button>
                            ) : (
                              <Button
                                style={{
                                  backgroundColor:
                                    this.state.hover &&
                                    this.state.hoverID == "trash-" + cart.dealID
                                      ? this.state.mouseover_color
                                      : this.state.button_color,
                                }}
                                data-id={"trash-" + cart.dealID}
                                bsStyle="danger"
                                onClick={this.removeItem.bind(
                                  this,
                                  cart.cartID,
                                  indexKey
                                )}
                              >
                                <i className="glyphicon glyphicon-trash" />
                              </Button>
                            )}
                          </td>
                        </tr>
                      )))
                    : null}
                  {!isEmpty(this.state.cart) && this.state.cart.length > 1 && (
                    <tr style={{ backgroundColor: "#f3f4f5" }}>
                      <td className="none"></td>
                      <td className="pull-right none">
                        {languageConfig[this.state.default_lang].sub_total}
                      </td>
                      <td className="subqty">{subTotalQty}</td>
                      <td className="subrprice">
                        <Currency
                          amount={subRetailPrice.toFixed(2)}
                          default_lang={this.state.default_lang}
                          className=""
                          default_currency={this.state.currency}
                        />
                      </td>
                      <td className="text-center suboprice">
                        <Currency
                          amount={subOfferPrice.toFixed(2)}
                          default_lang={this.state.default_lang}
                          className=""
                          default_currency={this.state.currency}
                        />
                      </td>
                      <td className="subshipping">
                        <b>
                          <Currency
                            amount={subTotalShipping.toFixed(2)}
                            default_lang={this.state.default_lang}
                            className=""
                            default_currency={this.state.currency}
                          />
                        </b>
                      </td>
                      {this.state.taxes == "enable" && (
                        <td className="text-center subtax">
                          {taxPerc.toFixed(2)}%
                        </td>
                      )}
                      <td className="total" colSpan="2">
                        <b>
                          <Currency
                            amount={total.toFixed(2)}
                            default_lang={this.state.default_lang}
                            className=""
                            default_currency={this.state.currency}
                          />
                        </b>
                      </td>
                    </tr>
                  )}
                  <tr style={{ backgroundColor: "#f3f4f5" }}>
                    <td
                      className="none"
                      colSpan={this.state.taxes == "enable" ? 6 : 5}
                    />
                    <td className="text-center none" colSpan="1">
                      {languageConfig[this.state.default_lang].grand_total}
                    </td>
                    <td className="text-center gtotal" colSpan="2">
                      <b>
                        <Currency
                          amount={total.toFixed(2)}
                          default_lang={this.state.default_lang}
                          className=""
                          default_currency={this.state.currency}
                        />
                      </b>
                    </td>
                  </tr>
                </tbody>
              </Table>
              <Row className="BtnRow">
                <Col md={12} xs={12}>
                  <Button
                    bsStyle="danger"
                    style={{
                      backgroundColor:
                        this.state.hover && this.state.hoverID == "checkout"
                          ? this.state.mouseover_color
                          : this.state.button_color,
                    }}
                    data-id={"checkout"}
                    onMouseEnter={this.hoverOn}
                    onMouseLeave={this.hoverOff}
                    type="submit"
                    disabled={!this.state.isValidateRemainingQty}
                    className="pull-right"
                  >
                    {languageConfig[this.state.default_lang].checkout}
                  </Button>
                  <Button
                    style={{
                      backgroundColor:
                        this.state.hover && this.state.hoverID == "Shoping"
                          ? this.state.mouseover_color
                          : this.state.button_color
                          ? this.state.button_color
                          : "#77C84E",
                    }}
                    data-id={"Shoping"}
                    onMouseEnter={this.hoverOn}
                    onMouseLeave={this.hoverOff}
                    bsStyle="success"
                    className="pull-right"
                    onClick={() => this.context.router.history.push(`/`)}
                  >
                    {languageConfig[this.state.default_lang].continue_shopping}
                  </Button>
                </Col>
              </Row>
            </form>
          </div>
        )}
        <hr />
      </div>
    );
  }
}

Cart.propTypes = {
  getCartDetail: PropTypes.func.isRequired,
  updateCart: PropTypes.func.isRequired,
  removeItem: PropTypes.func.isRequired,
  selectAttributes: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  error: state.frontReducer.error,
  cartError: state.frontReducer.cartError,
  UpdatecartStatus: state.frontReducer.UpdatecartStatus,
  cartDetail: state.frontReducer.cartDetail,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message,
  attribute: state.frontReducer.attribute,
});

export default compose(
  connect(mapStateToProps, {
    getCartDetail,
    renderAlert,
    clearAlert,
    updateCart,
    removeItem,
    selectAttributes,
  })
)(Cart);



// WEBPACK FOOTER //
// ./src/app/views/frontend/dashboard/Cart.js